@if (show) {
  <div class="assurant-loader-wraper">
    <div class="assurant-loader"></div>
  </div>
}
@if (!show) {
  <div>
    @if (showProgress()) {
      <div class="assurant-loader-wraper assurant-loader-wraper-inpage">
        <div class="assurant-loader"></div>
        @if (message) {
          <div class="message">
            {{ message }}
          </div>
        }
      </div>
    }
  </div>
}

